import { useState, useEffect, useMemo } from 'react';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';

export interface BarChartData {
  seriesData: any[];
  barNameList: any[];
}

export default function useRPDBarCharts(metric: string, barData: any[], topChartsType = '', tabType: 'stats' | 'countries'): BarChartData {
  // 柱状图 相关配置
  // 柱状图 y轴数据
  const [seriesData, setSeriesData] = useState<any>([]);

  const getValue = (list: any[]) => {
    return list?.length > 0 ? list?.find((item: any) => item.name == metric)?.value : '';
  }

  const getBarName = (item: any) => {
    if (tabType === 'countries') {
      return item?.market || item?.name || '';
    }

    return item?.gameName || item?.name;
  };

  // 获取 seriesData
  const createSeriesData = (data: any[]): any[] => {
    if (!Array.isArray(data) || data?.length < 1) return [];
    return data.map((item: any, i: number): any => ({
      type: 'bar',
      name: getBarName(item),
      value: topChartsType == 'stats-rpdedition-bar' || topChartsType == 'stats-rpdedition-bar-country' || topChartsType == 'pcconsole-country-bar' ? getValue(item.metrics ? item.metrics : []) : item[metric],
      cover: item.gameIcon || item.cover || item.market,
      itemStyle: {
        color: ECHARTSCOLOR[i],
      },
      label: {
        show: true,
        position: 'top',
        color: '#444',
        distance: 4,
        fontSize: 12,
        formatter: (params: any) => `${newMathFormat(Number(params.value), true)}`,
      }
    }));
  };

  useEffect(() => {
    setSeriesData(createSeriesData(barData));
  }, [metric, barData]);

  const barNameList = useMemo(() => {
    // return (Array.isArray(barData) && barData?.length > 0) ? barData?.map((item: any, i: number): any => (item ? (item.gameName || item.name) : '')) : [];
    if (tabType === 'countries') {
      if (!Array.isArray(barData)) return [];
      return barData.map(item => item?.market);
    }

    return (Array.isArray(barData) && barData?.length > 0) ? barData?.map((item: any, i: number): any => (item ? (item.gameName || item.name) : '')) : [];
  }, [tabType, barData]);

  return {
    seriesData,
    barNameList,
  };
}
